<template>
<div class="card">
  <div class="card-body help-card-body">
    <div class="text-center">
      <h4>Employment History</h4>
    </div>
    <hr>
    <h6><b>Company Location</b></h6>
    <p>You don't need the exact address the city and state are great.</p>
    <h6><b>Job Title</b></h6>
    <p>If the job title of the position you held does not effectively communicate the nature of the work preformed, and there is a generic job title that better communicates this information to the outside world, by all means use the generic title.
    </p>
    <h6><b>Job Duties</b></h6>
    <p>Provide a brief description of your key functional responsibilities or in other words the key things your responsible for doing.</p>
    <p>It's also important to provide guantitative descriptions of your work. So as to give the prospective employer a clearer understanding of the size, scope, and complexity of the job you were performing.</p>
    <h6><b>Job Accomplishments</b></h6>
    <p>These should be quatifiable accomplishments or in other words actions that can me measured. (Example: improved sales 5%)</p>
    <p>You should list a minimum of 2 to 5 major accomplishments or improvements that you brought about while in each poition. Copies of old performance evaluations and salary reviews may prove particularly helpful in identifying these key results.
    </p>
    <p>Start with a verb to force yourself to be concise.</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'history',
  components: {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style>

</style>
